// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M7bE","title":"Header_title__WGORt","left":"Header_left__Je1AQ","clinicName":"Header_clinicName__zsriG"};